let tableLabel = [
    {
        label: "序号2",
        prop: "idx",
        width: "60"
    },
    {
        label: "资产号",
        prop: "inmeterno",
        width: "125"
    },
    {
        label: "设备类型",
        prop: "deviceType",
        width: "300"
    },
    {
        label: "分组名称",
        prop: "rootName",
        width: "130"
    },
    {
        label: "设备名称",
        prop: "deviceName",
        width: "120"
    },
    {
        label: "时间",
        prop: "dataTime",
        width: "180"
    },
    {
        label: "总电量",
        prop: "totalenergy",
        width: "160"
    },
    {
        label: "A相电压",
        prop: "ua",
        width: "160"
    },
    {
        label: "B相电压",
        prop: "ub",
        width: "160"
    },
    {
        label: "C相电压",
        prop: "uc",
        width: "160"
    },
    {
        label: "A相电流",
        prop: "ia",
        width: "160"
    },
    {
        label: "B相电流",
        prop: "ib",
        width: "160"
    },
    {
        label: "C相电流",
        prop: "ic",
        width: "160"
    },
    {
        label: "功率因素",
        prop: "pfa",
        width: "140"
    },
]

const tableTitleWater = [
    {
        label: "序号2",
        prop: "idx",
        width: "60"
    },
    {
        label: "资产号",
        prop: "inmeterno",
        width: "125"
    },
    {
        label: "设备类型",
        prop: "deviceType",
        width: "300"
    },
    {
        label: "分组名称",
        prop: "rootName",
        width: "130"
    },
    {
        label: "设备名称",
        prop: "deviceName",
        width: "120"
    },
    {
        label: "时间",
        prop: "dataTime",
        width: "180"
    },
    {
        label: "总水量",
        prop: "totalvalue",
        width: "160"
    }
]

export { tableLabel, tableTitleWater }